import { render } from "./ModalPaymentInvoiceHistoryDetail.vue?vue&type=template&id=6c9ef7f2&scoped=true"
import script from "./ModalPaymentInvoiceHistoryDetail.vue?vue&type=script&lang=js"
export * from "./ModalPaymentInvoiceHistoryDetail.vue?vue&type=script&lang=js"

import "./ModalPaymentInvoiceHistoryDetail.vue?vue&type=style&index=0&id=6c9ef7f2&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9ef7f2"]])

export default __exports__